<!--
  What happens after launch, on a tinted band: the promises and what a
  retainer covers in plain sentences, beside the heartbeat they keep watch on.
-->
<template>
  <section id="support" class="bg-[#eef2f6] py-20 md:py-40 dark:bg-[#141926]">
    <div class="mx-auto max-w-7xl px-6 md:px-12 grid items-center gap-14 lg:grid-cols-12 lg:gap-16">
      <div class="lg:col-span-5">
        <h2 data-aos="fade" class="text-[clamp(2.25rem,4.6vw,3.75rem)] font-semibold leading-[1.05] tracking-[-0.035em] text-slate-800 dark:text-white">We stay after launch.</h2>
        <p class="text-lg md:text-xl text-slate-700/80 dark:text-white/65 leading-relaxed text-pretty max-w-xl mt-6">
          A monthly retainer keeps your application secure, up to date and running well, with critical issues answered within four hours by the developer who knows your code. No lock-in contract.
        </p>
        <p class="mt-8">
          <NuxtLink to="/ongoing-support" class="font-medium text-blu-600 underline decoration-dotted underline-offset-4 transition-colors hover:decoration-solid dark:text-blu-400">See what's included</NuxtLink>
        </p>
      </div>
      <div class="lg:col-span-7">
        <SupportPulse />
      </div>
    </div>
  </section>
</template>

